<template>
  <div :class="b()" :style="styleSizeName" ref="main" @click="handleClick">
    <div :class="b('text', { line: type === 'line', circle: type === 'circle' })">
      <p :style="styleSuffixName">{{ dataChart.label }}</p>
      <p :style="styleName">
        <avue-count-up v-if="dataChart.value" :end="Number(dataChart.value)"></avue-count-up>
      </p>
    </div>
    <avue-progress
      :color="color"
      :width="width"
      :showText="false"
      :strokeWidth="strokeWidth"
      :percentage="dataChart.data"
      :type="type"
      v-show="hasData"
    >
    </avue-progress>
    <template v-if="!hasData">
      <empty></empty>
    </template>
  </div>
</template>

<script>
import init from '@/mixins/chart';
export default {
  name: 'progress2',
  mixins: [init],
  computed: {
    styleSuffixName() {
      return {
        fontWeight: this.option.suffixFontWeight || 'normal',
        fontSize: (this.option.suffixFontSize || 40) + 'px',
        color: this.option.suffixColor || '#333'
      };
    },
    styleName() {
      return {
        marginBottom: this.option.split + 'px',
        fontWeight: this.option.fontWeight || 'normal',
        fontSize: (this.option.fontSize || 40) + 'px',
        color: this.option.color || '#333'
      };
    },
    type() {
      return this.option.type || 'line';
    },
    color() {
      return this.option.borderColor || '#333';
    },
    strokeWidth() {
      return this.option.strokeWidth || 14;
    },
    hasData() {
      return this.dataChart?.label;
    }
  },
  props: {
    option: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    handleClick() {
      this.progressClick(this.dataChart);
      this.clickFormatter &&
        this.clickFormatter({
          data: this.dataChart
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.avue-echart-progress2 {
  position: relative;
}
.avue-echart-progress2__text--circle {
  position: absolute;
  width: 100%;
  top: 50%;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  text-align: center;
}
.avue-echart-progress2__text--line {
  margin-bottom: 20px;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.avue-echart-progress2__text--line p {
  margin-right: 5px;
}
</style>
